export default __webpack_public_path__ + "static/bg-tac--mobile-f3612155f84c6b3e8552389250b45064.webp";